import './LandContractTermsPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import LandBottomLayout from '../common/LandBottomLayout'

export default class LandThirdPartySDKsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="LandContractTerms">
          <div className="LandContractTermsTitle">第三方SDK清单</div>

          <div className="LandD1">
            为保障应用功能的实现及安全稳定运行，部分功能会接入并由第三方提供的软件开发包（SDK）实现相关目的。我们将对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。
          </div>

          <div className="LandD">
            提示：第三方SDK可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。
          </div>

          <div className="LandD">Android</div>

          <div className="LandD">
            1. 阿里云号码认证服务 Android SDK（阿里巴巴提供）
          </div>

          <div className="LandD">
            官网链接：
            <a
              href="https://help.aliyun.com/document_detail/144231.html?spm=a2c4g.11186623.6.572.20977d50ySaQJm"
              target="_blank"
              style={{ color: '#0463C1' }}
            >
              https://help.aliyun.com/document_detail/144231.html?spm=a2c4g.11186623.6.572.20977d50ySaQJm
            </a>
          </div>

          <div className="LandD">收集信息类型：设备信息</div>

          <div className="LandD">用途：获取本机手机号码一键登录</div>

          <div className="LandD">iOS</div>

          <div className="LandD">
            1. 阿里云号码认证服务 iOS SDK（阿里巴巴提供）
          </div>

          <div className="LandD">
            官网链接：
            <a
              href="https://help.aliyun.com/document_detail/144186.html?spm=a2c4g.11186623.6.573.d3102dbdAby2Fj"
              target="_blank"
              style={{ color: '#0463C1' }}
            >
              https://help.aliyun.com/document_detail/144186.html?spm=a2c4g.11186623.6.573.d3102dbdAby2Fj
            </a>
          </div>

          <div className="LandD">收集信息类型：设备信息</div>

          <div className="LandD">用途：获取本机手机号码一键登录</div>
        </div>

        <LandBottomLayout {...this.props} />
      </div>
    )
  }
}
